import edit from './edit'

import { destroy as destroyForm } from 'redux-form'
import CreatePage, { TRANSITION_DURATION } from 'components/pages/create'

import PoolType from 'components/pages/create/create_type'
import PoolBasics from 'components/pages/create/create_basics'
import Participants from 'components/pages/create/create_preferences'
import PoolDescription from 'components/pages/create/create_description'
import PoolCoverCreate from 'components/pages/create/create_cover'
import PoolPrepublish from 'components/pages/create/create_prepublish'
import PoolPublish from 'components/pages/create/create_publish'
import PoolShare from 'components/pages/create/create_share'
import CampaignPage from 'components/pages/campaign'
import CountryBlockedError from 'components/common/country_blocked'
import { createCampaignEligibilityCheck } from 'lib/create_campaign_eligibility'
import { sendEnsightenEvent } from 'lib/ensighten_analytics'
import { POOLS_CAMPAIGN_TYPES } from 'shared/shared_consts'

import {
  NEW_CAMPAIGN_ID,
  create,
  resetRemoteOperation,
} from 'redux/modules/campaign'
import { getNewCampaignSelector } from 'redux/selectors/campaign'
import { mockForPreview } from 'redux/modules/txns'
import { updateQueryParams } from 'redux/modules/url'
import {
  getStepName,
  assertInitialStep,
  assignActionToRouterParams,
} from 'lib/route_utils'

const POOLS_INITIAL_STEP = 'basics'
const CROWDFUNDING_INITIAL_STEP = 'types'
const { PUBLIC_MONEY_POOL } = POOLS_CAMPAIGN_TYPES

export default (store, history) => ({
  path: 'create',
  getComponent(nextState, callback) {
    if (store.getState().current_user.moneypools_blocked) {
      return callback(null, CountryBlockedError)
    }
    return callback(null, CreatePage)
  },
  onEnter(nextState, replace) {
    store.dispatch((d, getState) => {
      d(create(PUBLIC_MONEY_POOL)) // creates the new campaign object.
      d(updateQueryParams(nextState.location)) // updates the state with query params
    })
    nextState.params.nextStep = getStepName('create', nextState.routes)
    if (nextState.params.nextStep !== 'share/:campaignId') {
      nextState.params.campaignId = NEW_CAMPAIGN_ID
      let INITIAL_STEP = POOLS_INITIAL_STEP

      // set initial step to 80/20 if user falls into the treatment unless is in the initial step
      if (
        store.getState().current_user.crowdfunding_enabled &&
        nextState.params.nextStep !== POOLS_INITIAL_STEP
      ) {
        INITIAL_STEP = CROWDFUNDING_INITIAL_STEP
      }

      assertInitialStep('create', INITIAL_STEP, nextState, replace)
    }
  },
  onChange(prevState, nextState) {
    assignActionToRouterParams(nextState)
    nextState.params.campaignId = NEW_CAMPAIGN_ID
    nextState.params.prevStep = getStepName('create', prevState.routes)
    nextState.params.nextStep = getStepName('create', nextState.routes)
  },
  childRoutes: [
    {
      path: 'types',
      component: PoolType,
    },
    {
      path: 'basics',
      campaignType: PUBLIC_MONEY_POOL,
      getComponent(nextState, callback) {
        return createCampaignEligibilityCheck(
          store.getState(),
          nextState,
          PUBLIC_MONEY_POOL,
          PoolBasics,
          callback
        )
      },
      onEnter(nextState) {
        if (
          nextState.location.action !== 'POP' ||
          !nextState.params.prevSteps ||
          nextState.params.prevState === 'types'
        ) {
          sendEnsightenEvent('MoneyPoolStart')
        }
      },
    },
    { path: 'preferences', component: Participants },
    { path: 'description', component: PoolDescription },
    { path: 'cover', component: PoolCoverCreate },
    {
      path: 'preview',
      component: CampaignPage,
      childRoutes: [edit(store, history)],
      onEnter(nextState) {
        if (nextState.location.action !== 'POP' || !nextState.params.prevStep) {
          store.dispatch((d, getState) => {
            const campaign = getNewCampaignSelector(getState())
            d(
              mockForPreview(
                campaign.share_progress,
                campaign.share_contributors,
                campaign.share_contributions
              )
            )

            // Destroy the form only once the transition has completed, so that the data in the form
            // doesn't disappear while transitioning.
            setTimeout(() => {
              d(destroyForm('create_basics'))
              d(destroyForm('create_preferences'))
              d(destroyForm('create_description'))
              d(destroyForm('create_cover'))
            }, TRANSITION_DURATION)
          })
        }
      },
    },
    { path: 'prepublish', component: PoolPrepublish },
    {
      path: 'publish',
      component: PoolPublish,
      onEnter(nextState) {
        if (nextState.location.action !== 'POP') {
          store.dispatch(resetRemoteOperation(NEW_CAMPAIGN_ID))
        }
      },
    },
    { path: 'share/:campaignId', component: PoolShare },
  ],
})
